import { ButtonHTMLAttributes, ReactNode } from "react";
import css from "./button.module.scss";

export enum ButtonStyle {
  Primary = "primary",
  Secondary = "secondary",
}

export enum ButtonType {
  Default = "default",
  Clear = "clear",
}

interface IButtonProps {
  children: ReactNode;
  active?: boolean;
  className?: string;
  fullWidth?: boolean;
  style?: ButtonStyle;
  type?: ButtonType;
  onClick?: () => void;
  onMouseEnter?: ButtonHTMLAttributes<HTMLButtonElement>["onMouseEnter"];
  onMouseLeave?: ButtonHTMLAttributes<HTMLButtonElement>["onMouseLeave"];
}

const Button = (props: IButtonProps) => {
  const {
    children,
    active,
    className,
    fullWidth,
    onClick,
    onMouseEnter,
    onMouseLeave,
    style = ButtonStyle.Primary,
    type = ButtonType.Default,
  } = props;

  return (
    <button
      className={`${css.button} ${css[style]} ${css[type]} ${fullWidth ? css.fullWidth : ""} ${className} ${active ? css.active : ""}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </button>
  );
};

export default Button;
